var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"debugbar"},[_c('button',{on:{"click":_vm.clearCache}},[_vm._v("clear cache")]),_c('button',{on:{"click":_vm.googleLogout}},[_vm._v("google logout")]),_c('button',{on:{"click":_vm.fbLogout}},[_vm._v("facebook logout")])])
}
var staticRenderFns = []

export { render, staticRenderFns }